import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            平台优势
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            五大核心优势，为您提供极致的在线观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {featuresData.map((feature) => (
            <article
              key={feature.id}
              className="group bg-background-50 rounded-xl p-6 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer text-center"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-primary-100 text-primary-500 rounded-2xl mx-auto mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${feature.icon} text-2xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}